export default __webpack_public_path__ + "static/media/img-b-top-distance-bg@3x.3ed6ff41.png";